import { z } from 'zod';

export const ImageSchema = z.object({
  title: z.string(),
  description: z.string(),
  variants: z.array(
    z.object({
      type: z.string(),
      format: z.string(),
      width: z.number().int(),
      height: z.number().int(),
      url: z.string().url(),
    }),
  ),
});
